var _OutlinedInfoCircle;

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) { void 0 === props[propName] && (props[propName] = defaultProps[propName]); } else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

import { OutlinedInfoCircle } from '@baidu/acud-icon';
import { OpenModuleContainer } from './OpenModuleContainer';
export default function OpenModule(_ref) {
  var backgroundSrc = _ref.backgroundSrc,
      logoSrc = _ref.logoSrc,
      title = _ref.title,
      content = _ref.content,
      tip = _ref.tip,
      agreement = _ref.agreement,
      button = _ref.button;
  return /*#__PURE__*/_jsx(OpenModuleContainer, {
    backgroundSrc: backgroundSrc
  }, void 0, /*#__PURE__*/_jsx("img", {
    className: "icloud-ui-activation-page-openmodule-logo",
    src: logoSrc
  }), /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-activation-page-openmodule-text"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-activation-page-openmodule-title"
  }, void 0, title), /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-activation-page-openmodule-content"
  }, void 0, content), tip && /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-activation-page-openmodule-tip"
  }, void 0, _OutlinedInfoCircle || (_OutlinedInfoCircle = /*#__PURE__*/_jsx(OutlinedInfoCircle, {})), /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-activation-page-openmodule-tip-content"
  }, void 0, tip)), agreement, button));
}
OpenModule.displayName = "OpenModule";
//# sourceMappingURL=es/OpenModule.js.map